/**
 * 文件名字符串转义
 */
export const htmlUnescape = (str: string) => {
    if (!str) {
        return str;
    }

    return str
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, '\'')
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/&amp;/g, '&');
};

/**
 * 获取文件名后缀
 */
export const getFileExt = (fileName: string) => {
    // 文件扩展名匹配正则
    const reg = /(?:\.([^.]+))?$/;
    const matches = reg.exec(fileName);
    if (matches && matches[1]) {
        return matches[1].toLowerCase();
    }
    return '';
};

/**
 * 获取文件名（不包括后缀）
 * @param fileName 完整文件名
 */
export const getFileName = (fileName: string) => {
    const fileExt = getFileExt(fileName);

    let name = fileName;
    if (fileExt.length) {
        name = name.slice(0, name.length - fileExt.length - 1);
    }
    return name;
};

/**
 * 获取格式化后的文件名（文件名+...+最后两个字符+文件后缀）
 * @param filename 文件名
 * @param len 截取的长度，默认为 2
 * @returns {
 *  left: 左侧文件名，省略的部分
 *  right: 右侧文件名
 * }
 */
export const getFormatFileName = (fileName: string, len: number = 2): {left: string, right: string} => {
    let left = '';
    let right = '';

    const fileExt = getFileExt(fileName);
    const fLen = fileName.length - fileExt.length - 1;
    left = htmlUnescape(fileName.slice(0, fLen - len));
    right = fileName.slice(fLen - len);

    return {left, right};
};


// 上传 sdk 静态资源
const STATIC_URL = 'https://rte-fe-static.bj.bcebos.com/rte-online/rte-fe-static/rte-js/uploadFile.js?v=1';

let tryTime = 0;
const allTime = 2;

/**
 * 动态加载上传 sdk
 */
export const createUploadFileScript = () => new Promise(resolve => {
    const script = document.createElement('script');
    script.type = 'text/javascript';

    script.src = STATIC_URL;

    script.onload = () => resolve(true);
    script.onerror = async error => {
        if (tryTime++ < allTime) {
            document.body.removeChild(script);
            const res = await createUploadFileScript();
            resolve(res);
            return;
        }
        console.error(error);
        resolve(false);
    };

    document.body.appendChild(script);
});

